module.exports = __webpack_public_path__ + "static/media/page-preview-3.a6b9c4d2.png";